export default "__VITE_ASSET__DvJ21EFd__"